"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.gr = exports.black = void 0;
var _styledComponents = require("styled-components");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
const white = exports.white = (0, _styledComponents.css)`
  ${(0, _breakpoints.default)("tablet", "down")} {
    ${function (_ref) {
  let {
    active,
    underlineColor
  } = _ref;
  return active && `
        color: #000;
        &:after {
          background: ${underlineColor ? underlineColor : "#b6a171"};
        }
      `;
}}
  }
  ${function (_ref2) {
  let {
    active
  } = _ref2;
  return active && `
    background-color: ${function (_ref3) {
    let {
      selectedUnderlineColor
    } = _ref3;
    return selectedUnderlineColor ? selectedUnderlineColor : "#000";
  }};
  `;
}}
  ${(0, _breakpoints.default)("desktop", "up")} {
    &:hover {
      &:after {
        background-color: ${function (_ref4) {
  let {
    selectedUnderlineColor
  } = _ref4;
  return selectedUnderlineColor ? selectedUnderlineColor : "#000";
}};
      }
    }
  }
  ${function (_ref5) {
  let {
    active,
    theme
  } = _ref5;
  return theme.selectedUnderlineColor && active && "background: #f3f3f3; color: #000;";
}}
  &:after {
    background-color: ${function (_ref6) {
  let {
    theme
  } = _ref6;
  return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#000";
}};
  }
  ${function (_ref7) {
  let {
    active
  } = _ref7;
  return active && `
      &:after {
      background-color: ${function (_ref8) {
    let {
      theme
    } = _ref8;
    return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#000";
  }};
      }
      `;
}}
  ${(0, _breakpoints.default)("tablet", "down")} {
    ${function (_ref9) {
  let {
    active,
    underlineColor
  } = _ref9;
  return active && `
        background: #f3f3f3;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        &:after {
        background: ${underlineColor ? underlineColor : "#b6a171"};
}
        `;
}}
  }
  ${(0, _breakpoints.default)("desktop", "up")} {
    &:hover {
      ${function (_ref10) {
  let {
    theme
  } = _ref10;
  return theme.selectedUnderlineColor && "background: #f3f3f3;";
}}
      &:after {
        background-color: ${function (_ref11) {
  let {
    theme
  } = _ref11;
  return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#000";
}};
      }
    }
  }
`;
const black = exports.black = (0, _styledComponents.css)`
  ${(0, _breakpoints.default)("tablet", "down")} {
    ${function (_ref12) {
  let {
    active,
    underlineColor
  } = _ref12;
  return active && `
        color: #000;
        &:after {
          background: ${underlineColor ? underlineColor : "#b6a171"};
        }
      `;
}}
  }
  ${function (_ref13) {
  let {
    active
  } = _ref13;
  return active && `
    background-color: ${function (_ref14) {
    let {
      selectedUnderlineColor
    } = _ref14;
    return selectedUnderlineColor ? selectedUnderlineColor : "#fff";
  }};
  `;
}}
  ${(0, _breakpoints.default)("desktop", "up")} {
    &:hover {
      ${function (_ref15) {
  let {
    selectedUnderlineColor
  } = _ref15;
  return selectedUnderlineColor && "background: #f3f3f3; color: #000;";
}}
      &:after {
        background-color: ${function (_ref16) {
  let {
    selectedUnderlineColor
  } = _ref16;
  return selectedUnderlineColor ? selectedUnderlineColor : "#fff";
}};
      }
    }
  }
  ${function (_ref17) {
  let {
    active,
    theme
  } = _ref17;
  return theme.selectedUnderlineColor && active && "background: #f3f3f3; color: #000;";
}}
  &:after {
    background-color: ${function (_ref18) {
  let {
    theme
  } = _ref18;
  return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#fff";
}};
  }
  ${function (_ref19) {
  let {
    active
  } = _ref19;
  return active && `
      &:after {
      background-color: ${function (_ref20) {
    let {
      theme
    } = _ref20;
    return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#fff";
  }};
      }
      `;
}}
  ${(0, _breakpoints.default)("tablet", "down")} {
    ${function (_ref21) {
  let {
    active
  } = _ref21;
  return active && `
        color: #fff;
        background: #000;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        &:after {
        background: ${"#000"};
}
        `;
}}
  }
  ${(0, _breakpoints.default)("desktop", "up")} {
    &:hover {
      ${function (_ref22) {
  let {
    theme
  } = _ref22;
  return theme.selectedUnderlineColor && "background: #f3f3f3;";
}}
      &:after {
        background-color: ${function (_ref23) {
  let {
    theme
  } = _ref23;
  return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#fff";
}};
      }
    }
  }
`;
const gr = exports.gr = (0, _styledComponents.css)`
  ${(0, _breakpoints.default)("tablet", "down")} {
    ${function (_ref24) {
  let {
    active
  } = _ref24;
  return active && `
        color: #000;
      `;
}}
  }
  ${function (_ref25) {
  let {
    active
  } = _ref25;
  return active && `
    background-color: ${function (_ref26) {
    let {
      selectedUnderlineColor
    } = _ref26;
    return selectedUnderlineColor ? selectedUnderlineColor : "#fff";
  }};
  `;
}}
  ${(0, _breakpoints.default)("desktop", "up")} {
    &:hover {
      ${function (_ref27) {
  let {
    selectedUnderlineColor
  } = _ref27;
  return selectedUnderlineColor && "background: #f3f3f3; color: #000;";
}}
      &:after {
        background-color: ${function (_ref28) {
  let {
    selectedUnderlineColor
  } = _ref28;
  return selectedUnderlineColor ? selectedUnderlineColor : "#fff";
}};
      }
    }
  }
  ${function (_ref29) {
  let {
    active,
    theme
  } = _ref29;
  return theme.selectedUnderlineColor && active && "background: #f3f3f3; color: #000;";
}}
  &:after {
    background-color: ${function (_ref30) {
  let {
    theme
  } = _ref30;
  return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#fff";
}};
  }
  ${function (_ref31) {
  let {
    active
  } = _ref31;
  return active && `
      &:after {
      background-color: ${function (_ref32) {
    let {
      theme
    } = _ref32;
    return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#fff";
  }};
      }
      `;
}}
  ${(0, _breakpoints.default)("tablet", "down")} {
    ${function (_ref33) {
  let {
    active
  } = _ref33;
  return active && `
        color: #fff;
        background: #111111;
        border-top: 1px solid #646464;
        border-bottom: 1px solid #646464;
        &:after {
        background: ${"#000"};
}
        `;
}}
  }
  ${(0, _breakpoints.default)("desktop", "up")} {
    &:hover {
      ${function (_ref34) {
  let {
    theme
  } = _ref34;
  return theme.selectedUnderlineColor && "background: #f3f3f3;";
}}
      &:after {
        background-color: ${function (_ref35) {
  let {
    theme
  } = _ref35;
  return theme.selectedUnderlineColor ? theme.selectedUnderlineColor : "#fff";
}};
      }
    }
  }
`;